<template>
  <div class="section" :class="{'mobile-section' : isMobile}">
    <div class="section-title" v-if="!isMobile">
      <h3>
        <svg class="svg-icon section-title-icon" aria-hidden="true" v-if="icon">
          <use :xlink:href="`#${icon}`"></use>
        </svg>
        {{title}}
      </h3>
      <slot name="more" />
    </div>
    <slot />
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: 'custom-section',
  components: {
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      isMobile: 'isMobile'
    })
  },
  created () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';

.section {
  padding: $sectionPadding; margin-top: $sectionSpace;
  background: #FFF;
  box-shadow: 0 1px 3px rgba(27, 95, 160, 0.1);

  &:first-child {
    margin-top: 0;
  }

}

.section-title {
  display: flex;
  justify-content: space-between;
  padding-top: 4px;
  @include lineFont(24, 400);
}

.section-title-icon {
  float: left;
  position: relative; top: -1px;
  margin-right: 7px;
}

.mobile-section {
  padding: 0 20px;
  margin-top: 0;
  box-shadow: none;
}
</style>
